<template>
  <div class="profile__card">
    <h4 class="profile__title">Editar senha</h4>

    <p v-show="hasUpdated" class="success-form-msg">
      Sua senha foi atualizada com sucesso!
      <BIconX @click="onCloseSuccessMessage" />
    </p>

    <form class="profile__form">
      <div class="profile__form-group">
        <div class="custom-form-control">
          <label>Senha</label>
          <input
            class="form-control"
            :class="[$v.user.password.$error ? 'form-control-invalid' : '']"
            v-model="$v.user.password.$model"
            type="password"
            placeholder="Nova senha"
          />
          <div v-if="$v.user.password.$error">
            <div v-if="!$v.user.password.required" class="error">
              Campo obrigatório
            </div>
            <div v-if="!$v.user.password.minLength" class="error">
              Deve conter no mínimo, 8 caracteres
            </div>
          </div>
        </div>

        <div class="custom-form-control">
          <label>Confirmar senha</label>
          <input
            class="form-control"
            :class="[
              $v.user.password_confirmation.$error
                ? 'form-control-invalid'
                : '',
            ]"
            v-model="$v.user.password_confirmation.$model"
            type="password"
            placeholder="Confirmar nova senha"
          />
          <div v-if="$v.user.password_confirmation.$error">
            <div v-if="!$v.user.password_confirmation.required" class="error">
              Campo obrigatório
            </div>
            <div v-if="!$v.user.password_confirmation.minLength" class="error">
              Deve conter no mínimo, 8 caracteres
            </div>
            <div
              v-if="!$v.user.password_confirmation.confirmPassword"
              class="error"
            >
              Senhas não correspondem
            </div>
          </div>
        </div>
      </div>

      <button class="button3" @click.prevent="updateUserPassword">
        Salvar nova senha
      </button>
    </form>
  </div>
</template>

<script>
import { userMethods } from "../state/helpers";
import { required, minLength, sameAs } from 'vuelidate/lib/validators';

export default {
  name: 'PasswordForm',
  data() {
    return {
      hasUpdated: false,
      user: {
        password: '',
        password_confirmation: '',
      },
    };
  },
  validations: {
    user: {
      password: {
        required,
        minLength: minLength(8),
      },
      password_confirmation: {
        required,
        minLength: minLength(8),
        confirmPassword: sameAs('password'),
      },
    },
  },
  mounted() {
    let user = Object.assign({}, this.$store.state.user.currentUser);
    this.user.id = user.id;
  },
  methods: {
    ...userMethods,
    async updateUserPassword() {
      this.$v.$touch();

      if (this.$v.user.$invalid) return;

      const payload = Object.assign({}, this.user);
      await this.updateUser(payload);

      this.hasUpdated = true;
      this.loading = false;
    },
    onCloseSuccessMessage() {
      this.hasUpdated = false;
    }
  }
};
</script>
